// Colour sequence — matches Power BI assignment order exactly
export const higginsColors = [
  '#e3a711',  // amber/gold      — colour 1 (primary series)
  '#c56055',  // coral/red       — colour 2
  '#a26d97',  // mauve           — colour 3
  '#6d5f88',  // purple          — colour 4
  '#7d7d7d',  // grey            — colour 5
  '#93b856',  // green           — colour 6
  '#55a0d3',  // blue            — colour 7
  '#406685',  // dark blue       — colour 8
];

export const higginsTableAccent = '#ebebeb';
export const higginsForeground   = '#424242';
